// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__hcg-k","modal":"Modal_modal__ALWqE","content":"Modal_content__EqzIc","actions":"Modal_actions__mn7PI"};